<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" :ignoreMaxTableItemLimit="true"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolPrPriceResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" withCustomRowActions
                                      detailInlineButtonType="showAttachmentEntity"
                                      :ignoreMaxTableItemLimit="true"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      :ignoreAdd="true"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="search"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   showName
                                                   customLabel="查看物料历史价"
                                                   @click="getMaterialHistoryPrice(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #left-header>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPrPrice'].checkedItems.length !== 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="selectVendor()"
                                    >锁定供应商
                                    </b-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPrPrice'].checkedItems.length < 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="infoRecordCategoryVisible = true"
                                    >回传SAP
                                    </b-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPrPrice'].checkedItems.length !== 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="showProvideHistory()"
                                    >报价历史
                                    </b-button>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPrPrice'].checkedItems.length < 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="dialogUpdateTermsTaxRateVisible = true"
                                    >更新条款与税率
                                    </b-button>
                                    <mini-button :disable="$_notChecked" :loading="downloadLoading"
                                                 @btnClick="$_downloadBomDrawing">
                                        <i class="fa-solid fa-file-zipper"></i>
                                        技术文件下载
                                    </mini-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog
            title="历史报价"
            :center="true"
            :visible.sync="dialogHisPriceVisible">
            <el-table
                :data="tableData"
                height="250"
                border
                style="width: 100%">
                <el-table-column
                    prop="price"
                    label="报价(不含税单价)"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="supplyCycle"
                    label="供货周期(日历日)"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="taxRate"
                    label="税率">
                </el-table-column>
                <el-table-column
                    prop="moneyType"
                    label="币种">
                </el-table-column>
                <el-table-column
                    prop="deliverItems"
                    label="交付条款">
                </el-table-column>
                <el-table-column
                    prop="payItems"
                    label="付款条款">
                </el-table-column>
                <el-table-column
                    prop="periodValidity"
                    label="有效期(日历日)">
                </el-table-column>
                <el-table-column
                    prop="offerPriceTime"
                    label="日期时间">
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog
            title="Info Record Category"
            :center="true"
            :visible.sync="infoRecordCategoryVisible">
            <el-select v-model="infoRecordCategory" placeholder="请选择">
                <el-option v-for="item in infoRecordCategoryOptions" :key="item.value" :label="item.label"
                           :value="item.value">
                </el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button @click="infoRecordCategoryVisible = false">取 消</el-button>
                <el-button type="primary" :loading="returnToSapLoading" @click="returnToSap">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="更新条款与税率" :visible.sync="dialogUpdateTermsTaxRateVisible">
            <el-form :inline=true>
                <el-form-item label="税率" required>
                    <el-select filterable style="width:93%;" v-model="taxRate" placeholder="请选择">
                        <el-option
                            v-for="item in taxRateList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="交付条款" required>
                    <el-select filterable style="width:93%;" v-model="deliverItems" placeholder="请选择">
                        <el-option
                            v-for="item in deliverItemOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="付款条款" required>
                    <el-select filterable style="width:93%;" v-model="payItems" placeholder="请选择"
                               :popper-append-to-body="false" class="option-style">
                        <el-option
                            v-for="item in payItemOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogUpdateTermsTaxRateVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateTaxRateTerms">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// Author Shi Wen Long
// Date 2021-06-25 10:35:42

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import {mapActions} from 'vuex';
import {
    getOptionsDeliverTerms,
    getOptionsPaymentTerms,
    getOptionsTaxRates
} from "@/model/sithMes/stool/TermsAndTaxRate.js";
import PageMaterialDownloadBomDrawingMixin from "@/views/sithMesII/pds/stuffs/page-material-download-bom-drawing-mixin";
import MiniButton from "@/components/common/buttons/MiniButton.vue";

export default {
    name: "sithMesStoolPrPriceListView",
    components: {MiniButton},
    mixins: [emCommonListMixin, emCommonApiMixin, PageMaterialDownloadBomDrawingMixin],
    data() {
        return {
            dialogHisPriceVisible: false,
            infoRecordCategoryVisible: false,
            dialogUpdateTermsTaxRateVisible: false,
            tableData: [],
            infoRecordCategory: '',
            deliverItems: 'DDP',
            deliverItemOptions: getOptionsDeliverTerms(),
            payItems: 'A120',
            payItemOptions: getOptionsPaymentTerms(),
            taxRate: 'JK',
            taxRateList: getOptionsTaxRates(),
            infoRecordCategoryOptions: [
                {
                    label: '0 : Standard',
                    value: '0'
                }, {
                    label: '2 : Consignment',
                    value: '2'
                }, {
                    label: '3 : Subcontracting',
                    value: '3'
                }, {
                    label: 'P : Pipeline',
                    value: 'P'
                }
            ],
            returnToSapLoading: false
        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return 'sithMesStoolPrPrice';
        },
        $_rowMaterialKey() {
            return 'matCode';
        }
    },
    methods: {
        ...mapActions("base", ["showSuccess", "showDanger", "showWarning"]),
        getMaterialHistoryPrice(row) {
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPrPrice/findMaterialHistoryPrice";
            this.$_emApiMixin_post(url, row)
                .then(response => {
                    this.$refs['emTable'].$_emCustomVuexMixin_voStore = response.data;
                })
        },
        selectVendor() {
            let row = this.$store.state[this.modelName].entity;
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPrPrice/selectVendor";
            this.$_emApiMixin_post(url, row)
                .then(response => {
                    this.showSuccess({userAlertSuccessStr: "锁定成功！"});
                    this.$refs['emTable'].$_emCustomVuexMixin_voStore = response.data;
                });
        },
        returnToSap() {
            let ids = this.$store.state[this.modelName].checkedItems;
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPrPrice/returnToSap/" + this.infoRecordCategory;
            this.returnToSapLoading = true;
            this.$_emApiMixin_post(url, ids)
                .then((result) => {
                    this.infoRecordCategoryVisible = false;
                    this.showSuccess({userAlertSuccessStr: "发送成功！"});
                }).finally(() => this.returnToSapLoading = false);
        },
        updateTaxRateTerms() {

            this.dialogUpdateTermsTaxRateVisible = false;

            let ids = this.$store.state['sithMesStoolPrPrice'].checkedItems.join(',');

            this.$_emApiMixin_post(`${this.$_emApiMixin_moduleBaseApi("sithMesStoolPrPrice")}/sithMesStoolPrPrice/updateTaxRateTerms?ids=` + ids, {
                'taxRate': this.taxRate,
                'deliverItems': this.deliverItems,
                'payItems': this.payItems
            })
                .then(response => {
                    commonViewsUtil.showSuccess(this, "更新完成！");
                    this.$refs.emListFilter.doQuery();
                });
        },
        showProvideHistory() {

            this.dialogHisPriceVisible = true;

            this.tableData = [];

            let row = this.$store.state[this.modelName].entity;
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolPrPrice/searchHistoryPriceRecord/" + row.id;
            this.$_emApiMixin_post(url, {})
                .then((result) => {
                    for (let item of result.data.list) {
                        this.tableData.push({
                            'price': item.price,
                            'supplyCycle': item.supplyCycle,
                            'taxRate': item.taxRate,
                            'moneyType': item.moneyType,
                            'deliverItems': item.deliverItems,
                            'payItems': item.payItems,
                            'periodValidity': item.periodValidity,
                            'offerPriceTime': item.offerPriceTime,
                        });
                    }
                    console.log(this.tableData);
                });
        },
        getDetailInlineButtonType(row) {
            if (row.attachments) {
                return 'showAttachmentEntity';
            }

            return 'showEntity';

        },
    },
    mounted() {
        if (this.$route.query.hasOwnProperty('idList')) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idListFilter', Array.from(this.$route.query.idList.split(",")));
            this.$refs.emListFilter.doQuery();
        } else if (this.$route.query.hasOwnProperty('id')) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.id);
            this.$refs.emListFilter.doQuery();
        } else {
            this.$refs["emListFilter"].doQuery();
        }
        //let fields = this.$refs['emTable'].$_emCustomVuexMixin_voConfigs;
        //let selectedLabels = ['prCode','prItem','matCode','vendorNameCh','vendorNameEn','remark','price','taxRate','moneyType'];
        //localStorage['em-table-custom-fields-sithMesStoolPrPrice-rows'] = JSON.stringify(fields.filter((field) => selectedLabels.indexOf(field.key) !== -1));
        //this.$refs['emTable'].tableColumnsReload();
    }
};
</script>

<style lang="scss" scoped>
.option-style {
    ::v-deep.el-select-dropdown {
        width: 50% !important;
    }
}
</style>
